/**
 * Rituel en 5 étapes — Maison Atlas
 * Custom element <rituel-section> that toggles between the hero visual
 * and per-step packshots on click, with a fade transition.
 *
 * Behavior:
 *  - On step click: fade swap of image + caption (0 → step index).
 *  - On same step re-clicked: returns to hero (step "0").
 *  - Keyboard accessible via native <button> elements with aria-pressed.
 */

class RituelSection extends HTMLElement {
  constructor() {
    super();
    this.activeStep = '0';
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-step-button]');
    this.images = this.querySelectorAll('[data-step]');
    this.captions = this.querySelectorAll('.rituel__caption-text');

    this.boundClick = this.handleStepClick.bind(this);
    this.buttons.forEach((btn) => btn.addEventListener('click', this.boundClick));
  }

  disconnectedCallback() {
    this.buttons?.forEach((btn) => btn.removeEventListener('click', this.boundClick));
  }

  handleStepClick(event) {
    const button = event.currentTarget;
    const step = button.dataset.stepButton;
    if (!step) return;

    // Toggle: if same step clicked, return to hero
    const next = step === this.activeStep ? '0' : step;
    this.setActiveStep(next);
  }

  setActiveStep(step) {
    this.activeStep = step;

    this.buttons.forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.stepButton === step ? 'true' : 'false');
    });

    this.images.forEach((img) => {
      const isActive = img.dataset.step === step;
      img.classList.toggle('rituel__image--active', isActive && img.matches('img'));
      img.classList.toggle('rituel__placeholder--active', isActive && !img.matches('img'));
      img.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.captions.forEach((cap) => {
      const isActive = cap.dataset.step === step;
      cap.classList.toggle('rituel__caption-text--active', isActive);
      cap.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }
}

if (!customElements.get('rituel-section')) {
  customElements.define('rituel-section', RituelSection);
}
